import { isEditMode } from 'pro-gallery-lib';
var MediaScrollHelper = /** @class */ (function () {
    function MediaScrollHelper(config) {
        var _this = this;
        this.config = config;
        this.scrollHelpers = [];
        this.stop = function (idx) {
            for (var _i = 0, _a = _this.scrollHelpers; _i < _a.length; _i++) {
                var scrollHelper = _a[_i];
                if (scrollHelper.findItem(idx)) {
                    scrollHelper.stop(idx);
                }
            }
        };
        this.initializePlayState = function () {
            for (var _i = 0, _a = _this.scrollHelpers; _i < _a.length; _i++) {
                var scrollHelper = _a[_i];
                scrollHelper.initializePlayState();
            }
        };
        this.onScroll = function (_a) {
            var top = _a.top, left = _a.left;
            if (!_this.scrollHelpers.length) {
                _this.top = top || _this.top;
                _this.left = left || _this.left;
            }
            for (var _i = 0, _b = _this.scrollHelpers; _i < _b.length; _i++) {
                var scrollHelper = _b[_i];
                scrollHelper.onScroll({ top: top, left: left });
            }
        };
        this.handleEvent = function (event) {
            for (var _i = 0, _a = _this.scrollHelpers; _i < _a.length; _i++) {
                var scrollHelper = _a[_i];
                scrollHelper.handleEvent(event);
            }
        };
        this.updateGalleryStructure = function (data) {
            if (data.isSSR) {
                return;
            }
            for (var _i = 0, _a = _this.scrollHelpers; _i < _a.length; _i++) {
                var scrollHelper = _a[_i];
                scrollHelper.updateGalleryStructure(data);
            }
            if (_this.scrollHelperPromise) {
                _this.latestGalleryStructure = data;
                return;
            }
            _this.latestGalleryStructure = data;
            if (isEditMode()) {
                return;
            }
            if (!data.galleryStructure.galleryItems.some(function (item) {
                return _this.config.some(function (c) { return c.supportedItemsFilter(item); });
            })) {
                return;
            }
            _this.scrollHelperPromise = import(
            /* webpackChunkName: "proGallery_videoScrollHelper" */ './mediaScrollHelper')
                .then(function (_a) {
                var VideoScrollHelper = _a.default;
                for (var _i = 0, _b = _this.config; _i < _b.length; _i++) {
                    var config = _b[_i];
                    _this.scrollHelpers.push(new VideoScrollHelper(config.onSetPlayingIdx, config.supportedItemsFilter, config.getPlayTrigger));
                }
                _this.updateGalleryStructure(_this.latestGalleryStructure);
                _this.onScroll({ top: _this.top, left: _this.left });
            })
                .catch(function (e) {
                console.error('Failed to load videoScrollHelper. error: ' + e);
            });
        };
        this.left = 0;
        this.top = 0;
    }
    return MediaScrollHelper;
}());
export default MediaScrollHelper;
//# sourceMappingURL=mediaScrollHelperWrapper.js.map